<template>
  <div>
    <div class="performance-chart-loading" v-if="onLoading">
      <ProcessingLoader />
    </div>

    <div class="performance-chart" v-else-if="graph[0].data.length > 0">
      <apexchart
        height="100%"
        width="100%"
        type="area"
        :series="graph"
        :options="chartOptions"
      ></apexchart>
    </div>

    <div v-else class="performance-graph-no-data">
      <div class="no-data-label">No data</div>
      <img :src="performance_no_data" style="width: 100%" />
    </div>

    <div v-if="filter_chart && !graph[0].data.length">
      <div class="filter-chart">
        <div>
          Range: <span>{{ dateFormat(filter_chart.start_date) }}</span> -
          <span>{{ dateFormat(filter_chart.end_date) }}</span>
          <span
            role="button"
            v-b-tooltip.hover
            title="Reload the chart"
            @click="reload"
          >
            <img :src="refresh_icon" class="icon"
          /></span>
        </div>
        <div>
          <span
            role="button"
            v-b-tooltip.hover
            title="Apply filter range date"
            @click="openFilterModal"
          >
            <img :src="setting_icon"
          /></span>
        </div>
      </div>
    </div>
    <FilterChartModal
      v-if="showFilterChartModal"
      @closed="showFilterChartModal = false"
    />
  </div>
</template>

<script>
import Dollar from "../../../../public/common/dollar.png";
import FilterChartModal from "./modals/FilterChartModal.vue";
import number_formatter from "../../../helpers/formatters/number_formatter";
import PerformanceNoData from "../../../assets/images/performance-graph-no-data.svg";
import ProcessingLoader from "../../commons/alerts/ProcessingLoader.vue";
import RefreshIcon from "../../../../public/common/refresh.svg";
import SettingsIcon from "../../../../public/common/settings.svg";

import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "PerformanceChart",
  data() {
    return {
      dollar_icon: Dollar,
      performance_no_data: PerformanceNoData,
      refresh_icon: RefreshIcon,
      setting_icon: SettingsIcon,
      showFilterChartModal: false,
    };
  },
  components: { ProcessingLoader, FilterChartModal },
  computed: {
    ...mapState("dashboard", ["filter_chart", "performance_account"]),
    graph() {
      let i = 0;
      const data =
        this.performance_account && this.performance_account._data
          ? this.performance_account._data.data.map((item) => {
              i = i + 10;
              return {
                x: item.date,
                y: item.performance_percentage * 100,
                additionalData: item,
              };
            })
          : [];
      return [
        {
          name: "series1",
          data,
        },
      ];
    },
    onLoading() {
      return this.performance_account._status._on_loading;
    },
    tooltip_data() {
      return this.performance_account && this.performance_account._data
        ? this.performance_account._data.data
        : null;
    },
    chartOptions() {
      const depositWithdraw = this.performance_account._data.data
        .filter((item) => item.deposit_withdraw != 0)
        .map((item) => {
          return { x: new Date(item.date).getTime(), borderColor: "#4F505A" };
        });

      var self = this;

      return {
        annotations: {
          xaxis: depositWithdraw,
        },
        chart: {
          height: 319,
          type: "line",
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true,
              customIcons: [
                {
                  icon: `<svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2282_30274)">
                        <path d="M6 4.00024C5.60444 4.00024 5.21776 4.11754 4.88886 4.33731C4.55996 4.55707 4.30362 4.86942 4.15224 5.23488C4.00087 5.60033 3.96126 6.00246 4.03843 6.39042C4.1156 6.77839 4.30608 7.13475 4.58579 7.41446C4.86549 7.69416 5.22186 7.88464 5.60982 7.96181C5.99778 8.03899 6.39992 7.99938 6.76537 7.848C7.13082 7.69663 7.44318 7.44028 7.66294 7.11138C7.8827 6.78249 8 6.39581 8 6.00024C8 5.46981 7.78929 4.9611 7.41421 4.58603C7.03914 4.21096 6.53043 4.00024 6 4.00024ZM6 7.00024C5.80222 7.00024 5.60888 6.9416 5.44443 6.83171C5.27998 6.72183 5.15181 6.56565 5.07612 6.38293C5.00043 6.2002 4.98063 5.99913 5.01922 5.80515C5.0578 5.61117 5.15304 5.43299 5.29289 5.29314C5.43275 5.15329 5.61093 5.05804 5.80491 5.01946C5.99889 4.98087 6.19996 5.00068 6.38268 5.07636C6.56541 5.15205 6.72159 5.28022 6.83147 5.44467C6.94135 5.60912 7 5.80246 7 6.00024C7 6.26546 6.89464 6.51981 6.70711 6.70735C6.51957 6.89489 6.26522 7.00024 6 7.00024Z" fill="white" fill-opacity="0.5"/>
                        <path d="M10.647 6.95L10.425 6.822C10.525 6.27822 10.525 5.72078 10.425 5.177L10.647 5.049C10.8177 4.95051 10.9674 4.81936 11.0874 4.66303C11.2075 4.50671 11.2955 4.32827 11.3466 4.13791C11.3977 3.94755 11.4107 3.74899 11.3851 3.55358C11.3594 3.35816 11.2955 3.16972 11.197 2.999C11.0985 2.82828 10.9674 2.67863 10.8111 2.5586C10.6547 2.43857 10.4763 2.3505 10.2859 2.29943C10.0956 2.24836 9.89702 2.23528 9.7016 2.26094C9.50619 2.28661 9.31774 2.35051 9.14702 2.449L8.92452 2.5775C8.50429 2.21846 8.02135 1.94012 7.50002 1.7565V1.5C7.50002 1.10218 7.34199 0.720644 7.06068 0.43934C6.77938 0.158035 6.39785 0 6.00002 0C5.6022 0 5.22067 0.158035 4.93936 0.43934C4.65806 0.720644 4.50002 1.10218 4.50002 1.5V1.7565C3.97872 1.94078 3.49595 2.2198 3.07602 2.5795L2.85252 2.45C2.50774 2.25109 2.09806 2.19729 1.71361 2.30043C1.32916 2.40358 1.00143 2.65522 0.802521 3C0.603609 3.34478 0.549808 3.75446 0.652953 4.13891C0.756098 4.52336 1.00774 4.85109 1.35252 5.05L1.57452 5.178C1.47458 5.72178 1.47458 6.27922 1.57452 6.823L1.35252 6.951C1.00774 7.14991 0.756098 7.47764 0.652953 7.86209C0.549808 8.24654 0.603609 8.65622 0.802521 9.001C1.00143 9.34578 1.32916 9.59742 1.71361 9.70057C2.09806 9.80371 2.50774 9.74991 2.85252 9.551L3.07502 9.4225C3.4954 9.78159 3.97851 10.0599 4.50002 10.2435V10.5C4.50002 10.8978 4.65806 11.2794 4.93936 11.5607C5.22067 11.842 5.6022 12 6.00002 12C6.39785 12 6.77938 11.842 7.06068 11.5607C7.34199 11.2794 7.50002 10.8978 7.50002 10.5V10.2435C8.02133 10.0592 8.5041 9.7802 8.92402 9.4205L9.14752 9.5495C9.4923 9.74841 9.90198 9.80221 10.2864 9.69907C10.6709 9.59592 10.9986 9.34428 11.1975 8.9995C11.3964 8.65472 11.4502 8.24504 11.3471 7.86059C11.2439 7.47614 10.9923 7.14841 10.6475 6.9495L10.647 6.95ZM9.37302 5.062C9.54234 5.67553 9.54234 6.32347 9.37302 6.937C9.34346 7.04379 9.3502 7.15737 9.39219 7.2599C9.43418 7.36244 9.50905 7.44813 9.60502 7.5035L10.147 7.8165C10.2619 7.8828 10.3458 7.99204 10.3802 8.12017C10.4145 8.24831 10.3966 8.38484 10.3303 8.49975C10.264 8.61466 10.1547 8.69851 10.0266 8.73288C9.89847 8.76725 9.76193 8.7493 9.64702 8.683L9.10402 8.369C9.00797 8.31337 8.89614 8.29128 8.78614 8.30622C8.67615 8.32115 8.57426 8.37227 8.49652 8.4515C8.05148 8.90583 7.49081 9.22999 6.87502 9.389C6.76754 9.41663 6.6723 9.47924 6.60432 9.56696C6.53633 9.65468 6.49947 9.76252 6.49952 9.8735V10.5C6.49952 10.6326 6.44684 10.7598 6.35308 10.8536C6.25931 10.9473 6.13213 11 5.99952 11C5.86691 11 5.73974 10.9473 5.64597 10.8536C5.5522 10.7598 5.49952 10.6326 5.49952 10.5V9.874C5.49958 9.76302 5.46271 9.65518 5.39472 9.56746C5.32674 9.47974 5.2315 9.41713 5.12402 9.3895C4.5082 9.22984 3.94769 8.90498 3.50302 8.45C3.42528 8.37077 3.32339 8.31965 3.2134 8.30472C3.10341 8.28978 2.99157 8.31187 2.89552 8.3675L2.35352 8.681C2.29664 8.71435 2.23372 8.73612 2.16838 8.74505C2.10305 8.75398 2.0366 8.7499 1.97285 8.73305C1.9091 8.7162 1.84931 8.6869 1.79693 8.64684C1.74455 8.60679 1.70061 8.55677 1.66764 8.49966C1.63467 8.44256 1.61332 8.3795 1.60482 8.31411C1.59632 8.24872 1.60084 8.18229 1.61812 8.11865C1.63539 8.05502 1.66509 7.99543 1.70549 7.94331C1.74589 7.8912 1.7962 7.84759 1.85352 7.815L2.39552 7.502C2.4915 7.44663 2.56636 7.36094 2.60835 7.2584C2.65034 7.15587 2.65709 7.04229 2.62752 6.9355C2.4582 6.32197 2.4582 5.67403 2.62752 5.0605C2.65655 4.95394 2.64949 4.84077 2.60743 4.73865C2.56537 4.63652 2.49068 4.5512 2.39502 4.496L1.85302 4.183C1.73812 4.1167 1.65426 4.00746 1.61989 3.87933C1.58552 3.75119 1.60347 3.61466 1.66977 3.49975C1.73608 3.38484 1.84531 3.30099 1.97344 3.26662C2.10158 3.23225 2.23812 3.2502 2.35302 3.3165L2.89602 3.6305C2.99181 3.68626 3.10341 3.70861 3.21329 3.69403C3.32316 3.67946 3.42508 3.6288 3.50302 3.55C3.94806 3.09567 4.50873 2.77151 5.12452 2.6125C5.23234 2.58478 5.32782 2.52188 5.39584 2.43375C5.46386 2.34563 5.50052 2.23732 5.50002 2.126V1.5C5.50002 1.36739 5.5527 1.24021 5.64647 1.14645C5.74024 1.05268 5.86741 1 6.00002 1C6.13263 1 6.25981 1.05268 6.35357 1.14645C6.44734 1.24021 6.50002 1.36739 6.50002 1.5V2.126C6.49997 2.23698 6.53683 2.34482 6.60482 2.43254C6.6728 2.52026 6.76804 2.58287 6.87552 2.6105C7.49153 2.77008 8.05222 3.09494 8.49702 3.55C8.57476 3.62923 8.67665 3.68035 8.78664 3.69528C8.89664 3.71022 9.00847 3.68813 9.10452 3.6325L9.64652 3.319C9.70341 3.28565 9.76633 3.26388 9.83166 3.25495C9.89699 3.24602 9.96345 3.2501 10.0272 3.26695C10.0909 3.2838 10.1507 3.3131 10.2031 3.35316C10.2555 3.39321 10.2994 3.44323 10.3324 3.50034C10.3654 3.55744 10.3867 3.6205 10.3952 3.68589C10.4037 3.75128 10.3992 3.81771 10.3819 3.88135C10.3646 3.94498 10.335 4.00457 10.2946 4.05669C10.2542 4.1088 10.2038 4.15241 10.1465 4.185L9.60452 4.498C9.50905 4.55335 9.43457 4.63874 9.39269 4.74085C9.35082 4.84296 9.3439 4.95605 9.37302 5.0625V5.062Z" fill="white" fill-opacity="0.5"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_2282_30274">
                        <rect width="12" height="12" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                    `,
                  index: 4,
                  title: "tooltip of the icon",
                  class: "custom-icon",
                  click: function (chart, options, e) {
                    self.openFilterModal();
                  },
                },
              ],
            },
          },
          stacked: false,
          offsetX: -10,
          offsetY: 15,
        },
        grid: {
          show: false,
        },
        colors: ["#18a0fb"],
        stroke: {
          width: [1],
          curve: ["smooth", "straight", "smooth"],
          lineCap: "square",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: "light",
            type: "vertical",
            opacityFrom: 0.3,
            opacityTo: 0.3,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: this.xaxis_categories,
          type: "datetime",
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            minHeight: undefined,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
            offsetX: 2,
            offsetY: -8,
            format: this.numberOfMonths < 2 ? "dd MMM yy" : " MMM yy",
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          tickPlacement: "between",
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        zoom: {
          enabled: true,
          type: "x",
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.4,
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.4,
              width: 1,
            },
          },
        },
        tooltip: {
          enabled: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const nav_color_status = this.colorStatus(
              this.tooltip_data[dataPointIndex]["nav"]
            );
            const returns_color_status = this.colorStatus(
              this.tooltip_data[dataPointIndex]["daily_returns"]
            );
            const performance_color_status = this.colorStatus(
              this.tooltip_data[dataPointIndex]["perfomance"]
            );
            return `<div class="apexcharts-tooltip-performance"><ul class="tooltip-list">
              <li><div class="label">Daily NAV</div><div class="value ${nav_color_status}">$ ${number_formatter(
              this.tooltip_data[dataPointIndex]["nav"],
              2
            )}</div></li>
              <li><div class="label">Daily returns</div><div class="value ${returns_color_status}">$ ${number_formatter(
              this.tooltip_data[dataPointIndex]["daily_returns"],
              2
            )}<span class="dash">/</span> ${number_formatter(
              this.tooltip_data[dataPointIndex]["daily_returns_percentage"] *
                100,
              3
            )} %</div></li>
              <li><div class="label">Performance to date</div><div class="value ${performance_color_status}">$ ${number_formatter(
              this.tooltip_data[dataPointIndex]["perfomance"],
              2
            )}<span class="dash">/</span>${number_formatter(
              this.tooltip_data[dataPointIndex]["performance_percentage"] * 100,
              3
            )} %</div></li>
              <li><div class="label">Date</div><div class="value">${
                this.tooltip_data[dataPointIndex]["date"]
              }</div></li>
              ${
                this.tooltip_data[dataPointIndex]["deposit_withdraw"] != 0
                  ? `<li><div class="label">Deposit withdraw</div><div class="value">$ ${number_formatter(
                      this.tooltip_data[dataPointIndex]["deposit_withdraw"],
                      2
                    )}</div></li>`
                  : ""
              }
            </ul></div>`;
          }.bind(this),
        },
      };
    },
    xaxis_categories() {
      var labels = new Array(this.graph[0].data.length).fill("");

      if (labels.length > 0) {
        labels[0] = moment(this.graph[0].data[0].x).format("MMM YY");
        labels[labels.length - 1] = moment(
          this.graph[0].data[this.graph[0].data.length - 1].x
        ).format("MMM YY");
      }

      return labels;
    },
    numberOfMonths() {
      var data = this.performance_account._data.data;

      const dates = data.map((item) => item.date);
      const uniqueMonths = [
        ...new Set(dates.map((date) => date.substring(0, 7))),
      ];
      return uniqueMonths.length;
    },
  },
  methods: {
    colorStatus(value) {
      return value > 0 ? "green" : value < 0 ? "red" : "";
    },
    dateFormat(date) {
      return moment(date).format("DD MMM YYYY");
    },
    openFilterModal() {
      this.showFilterChartModal = true;
    },
    reload() {
      this.$store.commit("dashboard/set_filter_chart", null);
      this.$store.dispatch("dashboard/performance_account", {});
    },
  },
};
</script>

<style lang="scss">
@import "../../../styles/pages/dashboard/performance_chart.scss";
</style>
